import React from 'react';
import { AccordionDetails, makeStyles, GRAY } from '@applyboard/ui-components';
import { useIsMobile } from "../../../../../../../useIsMobile";
var useStyles = makeStyles({
  accordionContent: {
    padding: function padding(props) {
      return props.isMobile ? 0 : '0 0 0 64px';
    }
  }
});
var StyledAccordionDetails = function StyledAccordionDetails(_ref) {
  var accepted = _ref.accepted,
    children = _ref.children;
  var isMobile = useIsMobile();
  var classes = useStyles({
    isMobile: isMobile
  });
  return /*#__PURE__*/React.createElement(AccordionDetails, {
    className: classes.accordionContent,
    style: {
      color: accepted ? null : GRAY[15]
    }
  }, children);
};
export default StyledAccordionDetails;